import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Input, InputNumber, Typography, Spin } from "antd";
import { createInvoiceFromOrder } from "../../services/invoiceService";
import { toast } from "react-toastify";

const { Text } = Typography;

const CreateInvoiceFromOrderModal = ({ visible, onCancel, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await createInvoiceFromOrder(values.orderReference, values.defaultTaxRate);
      toast.success("Siparişten fatura başarıyla oluşturuldu");
      onSuccess();
    } catch (error) {
      if (!error.errorFields) {
        console.error("Error creating invoice from order:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Siparişten Fatura Oluştur"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={loading}>
          İptal
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Fatura Oluştur
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>
            Sipariş referansını girerek otomatik olarak fatura oluşturabilirsiniz. Sipariş kalemleri fatura kalemlerine dönüştürülecektir.
          </Text>
          <Form.Item
            name="orderReference"
            label="Sipariş Referansı"
            rules={[{ required: true, message: "Lütfen sipariş referansı girin" }]}
          >
            <Input placeholder="Referans numarası girin (örn: REF-001)" />
          </Form.Item>
          <Form.Item
            name="defaultTaxRate"
            label="Varsayılan KDV Oranı (%)"
            tooltip="Sipariş kaleminde KDV oranı girilmemişse bu oran kullanılır"
          >
            <InputNumber min={0} max={100} style={{ width: "100%" }} addonAfter="%" placeholder="18" />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default CreateInvoiceFromOrderModal;
